// src/app/store.js
import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../redux/auth/auth';
import portfolioReducer from '../redux/portfolio/portfolio';
import dashboardReducer from '../redux/dashboard/dashboard';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage
import { combineReducers } from 'redux';
import { getDashboard } from './dashboard/dashboard';

const persistConfig = {
    key: 'root',
    storage,
};

const rootReducer = combineReducers({
    dashboard: dashboardReducer,
    auth: authReducer,
    portfolio: portfolioReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
});

export const persistor = persistStore(store);
